import { Dispatch, MutableRefObject, SetStateAction } from "react";
import {
  ChatMessage,
  ChatMessagesGroup,
} from "../components/chat_v2/ChatMessagesList";
import useStateWithRef from "./useStateWithRef";

export const useMessages = (): [
  r: MutableRefObject<ChatMessage[]>,
  v: ChatMessage[],
  g: ChatMessagesGroup,
  u: Dispatch<SetStateAction<ChatMessage[]>>
] => {
  const [messagesRef, messages, _setMessages] = useStateWithRef<ChatMessage[]>(
    []
  );

  const groupedMessages = messages.reduce(
    groupMessages,
    {} as ChatMessagesGroup
  );

  return [messagesRef, messages, groupedMessages, _setMessages];
};

const groupMessages = (
  groups: ChatMessagesGroup,
  current: ChatMessage
): ChatMessagesGroup => {
  const dateString = current.date.toISOString().split("T")[0];

  if (!groups[dateString]) {
    groups[dateString] = [];
  }

  groups[dateString].push(current);
  return groups;
};
